import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import { CalendarStyles } from "../../../styles/styles";
import SearchInput from "../../../../common/components/UI/Search/SearchInput";
import { DateFnsFormats, formatAs } from "../../../../common-client2/src/services/ukgDateTime";

class HistoryPanel extends Component {
	constructor(props) {
		let logs = props.historyResponse.map(entry => ({
			...entry,
			managerSettingName: props?.managerSettingNames[entry.managerSettingId],
			dateDisplay: formatAs(entry.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT),
		}));
		super(props);
		this.state = {
			historyLog: logs,
			filteredHistoryLog: logs,
			expanded: true,
			searchValue: '',
		};
	}

	componentDidUpdate = (prevProps) => {
		if (this.props.historyResponse) {
			if (this.props.historyResponse !== prevProps.historyResponse) {
				let logs = this.props.historyResponse.map(entry => {
					return {
						...entry,
						managerSettingName: this.props.managerSettingNames[entry.managerSettingId],
						dateDisplay: formatAs(entry.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT),
					}
				});
				this.setState({
					historyLog: logs,
					filteredHistoryLog: logs,
				});
			}
		}
	}

	renderHistoryList = () => {
		const { classes, handleClick = () => { }, isClickable } = this.props;
		const { filteredHistoryLog } = this.state;

		if (!filteredHistoryLog.length) {
			return <div style={{ color: '#dedede', paddingLeft: 10 }}>None</div>;
		}

		return filteredHistoryLog.map((item, index) => {
			const isExpiredDueToInactivity = item.message === 'IsExpiredDueToInactivity' && item.employeeName === 'Auto-Expiry';
			const isAutoRefused = item.isAutoRefused || false;
			const hasValidationFailures = isAutoRefused && item.validationFailures && item.validationFailures.length > 0;

			return (
			  <div
				style={{
					cursor: isClickable ? 'pointer' : 'default',
					border: isAutoRefused ? '2px solid #f44336' : 'none',
					borderRadius: isAutoRefused ? '4px' : '0',
					backgroundColor: isAutoRefused ? '#ffebee' : 'transparent',
					padding: isAutoRefused ? '8px' : '0'
				}}
				onClick={() => handleClick(item.offerId)}
				key={'historyLog' + index}
				className={classes.historyItemContainer}
			  >
				<div className={classes.historyLogFirst}>
						<span className={classes.historyLogName}>{item.employeeName?.trim() || ""}</span>
				  		<span> {item.status?.trim() || ""} </span>
				  		<span className={classes.historyLogshiftTime}>{item.managerSettingName?.trim() || ""}</span>
				  {isExpiredDueToInactivity && <span> due to inactivity</span>}
				</div>
				<div className={classes.historyLogDate}>{item.dateDisplay}</div>

				{!isExpiredDueToInactivity && !!item.message && (
				  <span className={classes.historyLogName}>
					{`${item.employeeName} commented "${item.message}"`}
				  </span>
				)}

				{hasValidationFailures && (
				  <div style={{ marginTop: '8px', color: '#d32f2f' }}>
					<div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
					  Validation Rule Failures:
					</div>
					<ul style={{ margin: '0', paddingLeft: '16px', fontSize: '11px' }}>
					  {item.validationFailures.map((failure, failureIndex) => (
						<li key={`validation-${index}-${failureIndex}`} style={{ marginBottom: '2px' }}>
						  {failure}
						</li>
					  ))}
					</ul>
				  </div>
				)}
			  </div>
			);
		  });
		  
	}

	handleSearchFilter = (event) => {
		const { searchValue, historyLog } = this.state;

		let filteredHistoryLog = [];

		let searchFilter = (event.target.value === undefined) ? searchValue : event.target.value;
		let keys = ['employeeName', 'dateDisplay', 'managerSettingName', 'status'];
		if (searchFilter !== '') {
			for (const entry of historyLog) {
				for (const key in entry) {
					if (keys.includes(key)
						&& entry[key]
						&& entry[key].toLowerCase().includes(searchFilter.toLowerCase())) {
						filteredHistoryLog.push(entry)
						break;
					}
				}
			}
		} else {
			filteredHistoryLog = historyLog;
		}

		this.setState({
			searchValue: searchFilter,
			filteredHistoryLog: filteredHistoryLog,
		})
	}

	render() {
		const { classes, hasSearch } = this.props;
		const { searchValue } = this.state;
		let searchBar = (hasSearch) ?
			<SearchInput
				wrapperClass={classes.SearchInput}
				fullWidth={true}
				value={searchValue}
				placeholder={"Search"}
				onChange={this.handleSearchFilter}
			/> : ''
		return (
			<React.Fragment>
				{searchBar}
				{this.renderHistoryList()}
			</React.Fragment>
		);
	}
}
export default withStyles(CalendarStyles)(HistoryPanel);